import React, { useEffect, useState } from 'react';
import { ArrowUpRight, Newspaper } from 'lucide-react';
import { api, fmtDate } from '../api';
import { Card, SectionTitle } from '../ui';

export default function CyberNews() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get('/nis2/news').then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <Card className="mt-8 p-6" data-testid="cyber-news">
      <SectionTitle right={<a href="https://www.smart-info.it/blog/categories/cyber-security" target="_blank" rel="noreferrer" className="text-sm text-[#D4AF37] hover:underline" data-testid="cyber-news-all">Tutte le news</a>}>News Cyber Security</SectionTitle>
      {items === null ? <p className="text-sm text-[#7A7F87]">Caricamento…</p> : items.length === 0 ? <p className="text-sm text-[#7A7F87]" data-testid="cyber-news-empty">Nessuna news disponibile al momento.</p> : (
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
          {items.map((n, i) => (
            <a key={n.url} href={n.url} target="_blank" rel="noreferrer" className="group border border-[#1F242C] rounded-sm overflow-hidden hover:border-[#D4AF37]/60 transition-colors flex flex-col" data-testid={`cyber-news-item-${i}`}>
              {n.image ? <img src={n.image} alt="" loading="lazy" className="h-36 w-full object-cover" /> : <div className="h-36 grid place-items-center bg-[#0B0D10]"><Newspaper className="text-[#D4AF37]" /></div>}
              <div className="p-4 flex-1 flex flex-col">
                <span className="text-xs text-[#7A7F87] mb-1">{fmtDate(n.date)}</span>
                <span className="text-sm font-semibold leading-snug mb-2 group-hover:text-[#D4AF37] transition-colors">{n.title}</span>
                <span className="text-sm text-[#A3A3A3] line-clamp-3 flex-1">{n.summary}</span>
                <span className="text-xs text-[#D4AF37] mt-3 inline-flex items-center gap-1">Leggi sul sito<ArrowUpRight size={13} /></span>
              </div>
            </a>
          ))}
        </div>
      )}
    </Card>
  );
}
